import { Address } from '@/@types/client-api';

export const getFormattedAddressDescription = (
  address: Address,
  countryName?: string | null
): string => {
  const lines = [
    address.attention,
    address.company,
    address.address1,
    address.address2,
    (address.city ?? '') +
      (address.state || address.zip
        ? `, ${address.state ? address.state + ' ' : ''}${address.zip}${address.plus4 ? '-' + address.plus4 : ''}`
        : ''),
    countryName ?? address.country
  ];

  return lines.filter(line => !!line).join('\n');
};

export const getInlineFormattedAddress = (
  address: Address,
  countryName?: string | null
): string => {
  const state =
    (address.city ?? '') +
    (address.state || address.zip
      ? `, ${address.state ? address.state + ' ' : ''}${address.zip}${address.plus4 ? '-' + address.plus4 : ''}`
      : '');

  return `${address.address1}, ${address.address2 ? `${address.address2}, ` : ''}${state}, ${countryName ?? address.country}`;
};
